import { Component } from '@angular/core';

@Component({
    selector: 'app-facebook-share',
    standalone:true,
    imports: [],
    templateUrl: './facebook-share.component.html',
    styleUrl: './facebook-share.component.css'
})
export class FacebookShareComponent {
   pageUrl: string = ''; 
 
   get currentPageUrl(): string {
    return this.pageUrl || window.location.href;
  }

  // Sharing URLs
  get facebookShareUrl(): string {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentPageUrl)}`;
  }

  get twitterShareUrl(): string {
    return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.currentPageUrl)}&text=Check%20this%20out!`;
  }

  get linkedInShareUrl(): string {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentPageUrl)}`;
  }

  openShareWindow(url: string): void {
    window.open(url, '_blank', 'width=600,height=400');
  }
  

  // async shareOnFacebook() {
  //   try {
  //     const url = "https://thepdfleader.com/"; // The URL to be shared
  //     const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  //     window.open(shareUrl, '_blank', 'width=600, height=400');
  //   } catch (error) {
  //     console.error('Error capturing page or uploading image:', error);
  //   }
  // }
}




